// Currency formatting helpers (frontend)
export const CURRENCIES = [
  { code: "EUR", symbol: "€", label: "Euro", locale: "it-IT" },
  { code: "USD", symbol: "$", label: "US Dollar", locale: "en-US" },
  { code: "GBP", symbol: "£", label: "British Pound", locale: "en-GB" },
  { code: "CHF", symbol: "CHF", label: "Swiss Franc", locale: "de-CH" },
];

export function formatMoney(amount, currencyCode = "EUR") {
  const cur = CURRENCIES.find((c) => c.code === currencyCode) || CURRENCIES[0];
  const value = Number.isFinite(amount) ? amount : 0;
  try {
    return new Intl.NumberFormat(cur.locale, {
      style: "currency",
      currency: cur.code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${cur.symbol} ${value.toFixed(2)}`;
  }
}

export function currencySymbol(code = "EUR") {
  const cur = CURRENCIES.find((c) => c.code === code);
  return cur?.symbol || "€";
}
